import Conditions from '../constants/conditions';
import SchedulingComponents from '../constants/schedulingComponents';
import UserPermissions from '../constants/userPermissions';
import { PartialRecord, PermissionRules } from '../usePermissions';

type schedulingComponentRegistry = {
  [name in SchedulingComponents]: PermissionRules;
};

const SchedulingComponentRegistry: schedulingComponentRegistry = {
  HeaderButtonBar: {
    [UserPermissions.UNDO_REDO_ACTION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.VIEW_ROUTES]: true,
  },
  QuickAddButton: {
    [UserPermissions.CREATE_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  SchedulingContentDesktop: {
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  ViewMenu: {
    [UserPermissions.VIEW_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  OpenPanelButton: {
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
};

export default SchedulingComponentRegistry;
